module.exports = __webpack_public_path__ + "media/widget/Procedures-d5f83c9b.png";